module.exports = __webpack_public_path__ + "static/media/cigarettes_02_full.1e108889.png";